import { VFC } from 'react';

import { useSetSource } from '@/scenarios/legacy-player/hooks/useSetSource';
import { PlayerConfigProps } from '@/scenarios/legacy-player/types/config';

export const PlayerController: VFC<PlayerConfigProps> = (props) => {
    useSetSource(props);

    return null;
};
